import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { formatCurrency } from '../lib/format';
import { sendLead } from '../lib/webhook';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDollarSign, FiTrendingUp, FiMail, FiCalendar, FiLoader, FiCheck, FiX } = FiIcons;

const EstimatePanel = ({ estimate, formData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleAction = async (action) => {
    setIsSubmitting(true);
    setSubmitStatus(null);
    try {
      await sendLead({ ...formData, estimate, action, timestamp: new Date().toISOString() });
      setSubmitStatus('success');
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-brand-silver/30">
      <div className="px-8 py-6 text-white bg-brand-blue border-b-4 border-brand-gold">
        <h3 className="text-2xl font-bold flex items-center uppercase tracking-tight">
          <SafeIcon icon={FiDollarSign} className="h-7 w-7 mr-3 text-brand-gold" /> Analisi Finanziaria
        </h3>
      </div>
      <div className="p-8 space-y-8">
        <div className="grid grid-cols-2 gap-6">
          <div className="bg-brand-silver/10 rounded-2xl p-6 text-center border border-brand-silver/20">
            <div className="text-3xl font-black text-brand-blue">{formatCurrency(estimate.adrBase)}</div>
            <div className="text-xs uppercase font-bold text-brand-subtle tracking-widest mt-2 text-brand-gold">ADR Stimato</div>
          </div>
          <div className="bg-brand-silver/10 rounded-2xl p-6 text-center border border-brand-silver/20">
            <div className="text-3xl font-black text-brand-blue">{Math.round(estimate.occ * 100)}%</div>
            <div className="text-xs uppercase font-bold text-brand-subtle tracking-widest mt-2 text-brand-gold">Occupazione</div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-brand-blue/5 to-white border border-brand-gold/30 rounded-3xl p-8">
          <h4 className="font-bold text-brand-blue mb-6 text-center uppercase tracking-widest text-sm">Entrate Mensili Stimata</h4>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-black text-brand-blue mb-4">
              {formatCurrency(estimate.monthlyMin)} - {formatCurrency(estimate.monthlyMax)}
            </div>
            <div className="h-1.5 w-full bg-brand-silver/30 rounded-full mb-6 relative overflow-hidden">
              <div className="absolute inset-0 bg-brand-gold shadow-[0_0_15px_rgba(181,142,75,0.5)] w-2/3"></div>
            </div>
            <p className="text-brand-subtle font-medium text-sm">Valore Lordo di Mercato</p>
          </div>
        </div>

        {submitStatus === 'success' ? (
          <div className="bg-green-50 border-2 border-green-500 rounded-2xl p-6 text-center text-green-800 font-bold">
            Analisi inviata con successo! Verrai ricontattato.
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <button 
              onClick={() => handleAction('estimate_request')} 
              disabled={isSubmitting}
              className="bg-brand-gold text-white py-5 rounded-2xl font-black text-lg hover:bg-brand-blue transition-all shadow-xl shadow-brand-gold/20 flex items-center justify-center space-x-3"
            >
              {isSubmitting ? <SafeIcon icon={FiLoader} className="animate-spin" /> : <SafeIcon icon={FiMail} />}
              <span>RICEVI REPORT COMPLETO</span>
            </button>
            <button 
              onClick={() => handleAction('consultation_request')}
              disabled={isSubmitting}
              className="border-2 border-brand-blue text-brand-blue py-5 rounded-2xl font-black text-lg hover:bg-brand-blue hover:text-white transition-all flex items-center justify-center space-x-3"
            >
              <SafeIcon icon={FiCalendar} />
              <span>PRENOTA AUDIT GRATUITO</span>
            </button>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default EstimatePanel;